import {
    Box,
    MenuItem,
    Popover,
    Typography,
    useTheme,
    useMediaQuery,
    Select,
    Button,
    Tooltip,
    Checkbox,
    TextField,
    FormControl,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../config/AppContext";
import "./TaskFilter.scss";
import CommonUtil from "../../util/CommonUtils";
import CustomizedDateRangePicker from "./CustomizedDateRangePicker";
import dayjs from "dayjs";

export default function TaskFilter(props) {
    const {
        open,
        anchorEl,
        onClose,
        status,
        onApplyFilters = () => { },
        projectsList = [],
        startDate = null, setStartDate = () => { },
        endDate = null, setEndDate = () => { },
        setStatusFilter = () => { },
        projectFilter = "",
        setProjectFilter
    } = props;

    const { t } = useTranslation();
    const { mode } = useContext(AppContext);
    const theme = useTheme();
    const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
    const [tempProjectSearch, setTempProjectSearch] = useState("");
    const [tempProjectFilter, setTempProjectFilter] = useState(["all-project"]);
    const role = CommonUtil.getRoleCode();

    const menuItemStyle = {
        fontFamily: "Gotham",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "var(--fw-500)",
        backgroundColor: mode === "dark" ? "#1F1F1F" : "#FFFFFF",
        color: mode === "dark" ? "#f8f8f8cc" : "#242424cc",
        "&:hover": {
            backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
            color: "#FA9C2B",
        },
        "&.Mui-selected": {
            backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
            color: "#FA9C2B",
        },
        "&.Mui-selected:hover": {
            backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
            color: "#FA9C2B",
        },
    };

    const handleStatusChange = (event) => {
        const value = event.target.value;
        setStatusFilter(value);
    };

    useEffect(() => {
        if (projectFilter === undefined || projectFilter.length === 0) {
            setTempProjectFilter([
                "all-project",
                ...projectsList.map((project) => project.id),
            ]);
        } else {
            setTempProjectFilter([...projectFilter]);
        }
    }, [projectFilter, projectsList]);


    const handleResetApply = () => {
        setStatusFilter("");
        setStartDate(null);
        setEndDate(null);
        setTempProjectFilter([...projectsList.map((project) => project.id), "all-project"])
        onClose("Reset");
        onApplyFilters({
            projectIds: "",
            status: "",
            startDate: "",
            endDate: "",
        });
    }
    console.log(tempProjectFilter)
    const handleApplyFilter = () => {
        const selectedProject = tempProjectFilter.includes("all-project")
            ? []
            : tempProjectFilter.filter((v) => v !== "all-project");
        const filters = {
            projectIds: selectedProject.join(","),
            status: status,
            startDate: startDate ? dayjs.tz(startDate, CommonUtil.getTimeZoneId()).startOf("day").utc().format() : null,
            endDate: endDate ? dayjs.tz(endDate, CommonUtil.getTimeZoneId()).endOf("day").utc().format() : null,
        };
        setProjectFilter(selectedProject)
        onApplyFilters(filters);
        onClose("Apply");
    };

    const handleProjectFilterChange = (projectId) => {

        let newProjectFilter = [...tempProjectFilter];

        if (projectId === "all-project") {
            if (newProjectFilter.includes("all-project")) {
                newProjectFilter = [];
            } else {
                newProjectFilter = [
                    "all-project",
                    ...projectsList.map((project) => project.id),
                ];
            }
        } else {
            if (newProjectFilter.includes("all-project")) {
                newProjectFilter = newProjectFilter.filter((id) => id !== "all-project");
            }
            if (newProjectFilter.includes(projectId)) {
                newProjectFilter = newProjectFilter.filter((id) => id !== projectId);
            } else {
                newProjectFilter.push(projectId);
            }
            if (newProjectFilter.length === projectsList.length) {
                newProjectFilter.push("all-project");
            }
        }
        setTempProjectFilter(newProjectFilter);
    };

    return (
        <Popover
            id={open ? "simple-popover" : undefined}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            PaperProps={{
                style: {
                    overflow: "visible",
                    marginLeft:
                        role === "TEAM LEAD"
                            ? isXlScreen
                                ? "-155px"
                                : "-135px"
                            : isXlScreen
                                ? "-205px"
                                : "-175px",
                    width: "360px",
                    marginTop: 12,
                    padding: "24px",
                    background:
                        mode === "light" ? "var(--color-37)" : "var(--color-9-00)",
                },
            }}
        >
            <Typography
                variant="h6"
                style={{
                    font: "normal normal medium 18px/21px Gotham",
                    color: mode === "light" ? "var(--color-43)" : "var(--color-33)",
                }}
            >
                {t("RAL0224")}
            </Typography>
            <Box mt={2} mb={2} display="flex" flexDirection="column" gap={2}>
                <Box>
                    <Select
                        fullWidth
                        id="btn-select-status-popover"
                        name="status"
                        sx={{
                            borderRadius: "5px",
                            background:
                                mode === "light" ? "var(--color-42)" : "var(--color-47-50)",
                            font: "normal normal normal 16px/20px Gotham",
                            "& .MuiSelect-select": {
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color:
                                    mode === "light"
                                        ? "var(--color-43) !important"
                                        : "var(--color-33-80) !important",
                            },
                            "& .MuiOutlinedInput-notchedOutline ": {
                                border: "none !important",
                            },
                        }}
                        value={status || ""}
                        onChange={handleStatusChange}
                        displayEmpty
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            PaperProps: {
                                style: {
                                    marginLeft: -335,
                                    marginTop: -50,
                                }
                            }
                        }}
                    >
                        <MenuItem
                            value=""
                            id="select-state-id"
                            name="select-state-name"
                            sx={menuItemStyle}
                        >
                            {t("RAL0231")}
                        </MenuItem>

                        <MenuItem
                            value={"NOT STARTED"}
                            id="select-state-yettostart-id"
                            name="select-state-yettostart-name"
                            sx={menuItemStyle}
                        >
                            {t("RAL1106")}
                        </MenuItem>
                        <MenuItem
                            value={"IN PROGRESS"}
                            id="select-state-inprogress-id"
                            name="select-state-inprogress-name"
                            sx={menuItemStyle}
                        >
                            {t("RAL0659")}
                        </MenuItem>

                        <MenuItem
                            value={"COMPLETED"}
                            id="select-state-completed-id"
                            name="select-state-completed-name"
                            sx={menuItemStyle}
                        >
                            {t("RAL0661")}
                        </MenuItem>

                        <MenuItem
                            value={"OVERDUE"}
                            id="select-state-overdue-id"
                            name="select-state-overdue-name"
                            sx={menuItemStyle}
                        >
                            {t("RAL0660")}
                        </MenuItem>

                        <MenuItem
                            value={"ARCHIVED"}
                            id="select-state-archived-id"
                            name="select-state-archived-name"
                            sx={menuItemStyle}
                        >
                            {t("RAL0234")}
                        </MenuItem>
                    </Select>
                </Box>
                <Box>

                    <Select
                        id="dropdown-projectfilter"
                        value={tempProjectFilter}
                        onClose={() => {
                            if (tempProjectFilter.length === 0) {
                                setTempProjectFilter([...projectsList.map((project) => project.id), "all-project"])
                            }
                            setTempProjectSearch("")
                        }}
                        renderValue={(selected) => {
                            if (selected.includes("all-project")) {
                                return t("RAL1137");
                            }

                            const selectedprojects = projectsList.filter((project) =>
                                selected.includes(project.id)
                            );
                            const selectedProjectNames = selectedprojects
                                .map((project) => project.name)
                                .join(", ");
                            if (selectedProjectNames.length > 24) {
                                return (
                                    <Tooltip title={selectedProjectNames} placement="top">
                                        <span>{`${selectedProjectNames.substring(0, 24)}...`}</span>
                                    </Tooltip>
                                );
                            }
                            return selectedProjectNames || t("RAL1137");
                        }}
                        multiple
                        sx={{
                            width: "310px",
                            height: "50px",
                            borderRadius: "5px",
                            background:
                                mode === "light"
                                    ? "var(--color-42)"
                                    : "var(--color-47-50)",
                            font: "normal normal normal 16px/20px Gotham",
                            "& .MuiSelect-select": {
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color:
                                    mode === "light"
                                        ? "var(--color-43) !important"
                                        : "var(--color-33-80) !important",
                            },
                            "& .MuiOutlinedInput-notchedOutline ": {
                                border: "none !important",
                            },
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            PaperProps: {
                                style: {
                                    marginLeft: -335,
                                    marginTop: -50,
                                }
                            },
                            disableAutoFocusItem: true,
                            autoFocus: false,
                        }}
                    >
                        <MenuItem
                            onKeyDown={(e) => e.stopPropagation()}
                            sx={{
                                fontFamily: "Gotham",
                                fontStyle: "normal",
                                fontVariant: "normal",
                                fontWeight: "var(--fw-500)",
                                backgroundColor:
                                    mode === "dark"
                                        ? "#1F1F1F!important"
                                        : "#FFFFFF!important",
                                color: mode === "dark" ? "#f8f8f8cc" : "#242424cc",
                                "&:hover": {
                                    backgroundColor: "#1F1F1F",
                                },
                                "&.Mui-selected, &.Mui-selected:hover": {
                                    backgroundColor:
                                        mode === "dark"
                                            ? "#362C20!important"
                                            : "#FFF9F2!important",
                                    color: "#FA9C2B",
                                },
                            }}
                        >
                            <TextField
                                className="TopFilter-mb"
                                id="select-search-projectfilter"
                                placeholder={t("RAL1136")}
                                variant="outlined"
                                fullWidth
                                size="small"
                                value={tempProjectSearch}
                                autoComplete="off"
                                onChange={(e) => setTempProjectSearch(e.target.value)}
                                InputLabelProps={{ shrink: false }}
                                InputProps={{
                                    onClick: (e) => {
                                        e.stopPropagation();
                                    },
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "&:hover fieldset": {
                                            border: "1px solid var(--border-color-1)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "1px solid var(--border-color-1)",
                                        },
                                        "& input::placeholder": {
                                            color:
                                                mode === "light"
                                                    ? "#24242480 !important"
                                                    : "#f8f8f880 !important",
                                            opacity: 1,
                                        },
                                        "& input": {
                                            color:
                                                mode === "light"
                                                    ? "#24242480 !important"
                                                    : "#f8f8f880 !important",
                                            opacity: 1,
                                        },
                                    },
                                }}
                            />
                        </MenuItem>
                        <Box
                            sx={{
                                maxHeight: 260,
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                                scrollbarColor: "var(--background-color-38) transparent",
                                "&::-webkit-scrollbar": {
                                    width: "8px",
                                    backgroundColor: "transparent",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    borderRadius: "10px",
                                },
                            }}
                        >
                            <MenuItem
                                value={t("RAL1137")}
                                id="select-item-projectfilter"
                                onClick={() => handleProjectFilterChange("all-project")}
                                selected={tempProjectFilter?.includes("all-project")}
                                sx={{
                                    fontFamily: "Gotham",
                                    fontStyle: "normal",
                                    fontVariant: "normal",
                                    fontWeight: "var(--fw-500)",
                                    backgroundColor: mode === "dark" ? "#1F1F1F" : "#FFFFFF",
                                    color: mode === "dark" ? "#f8f8f8cc" : "#242424cc",
                                    "&:hover": {
                                        backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
                                        color: "#FA9C2B",
                                    },
                                    "&.Mui-selected": {
                                        backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
                                        color: "#FA9C2B",
                                    },
                                    "&.Mui-selected:hover": {
                                        backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
                                        color: "#FA9C2B",
                                    },
                                }}
                            >
                                <Checkbox
                                    id="select-check-projectfilter"
                                    checked={
                                        tempProjectFilter.includes("all-project") ||
                                        tempProjectFilter?.length === projectsList?.length + 1
                                    }
                                    sx={{
                                        "& .MuiSvgIcon-root": {
                                            border:
                                                mode === "dark"
                                                    ? "1px solid #4D4D4D"
                                                    : "1px solid #B2B2B2",
                                            borderRadius: "4px",
                                            width: "20px",
                                            height: "20px",
                                        },
                                        "&.Mui-checked .MuiSvgIcon-root": {
                                            border: "none",
                                        },
                                        "&.Mui-checked": {
                                            color: "orange",
                                        },
                                        "& .MuiSvgIcon-root path": {
                                            fill: "transparent",
                                        },
                                        "&.Mui-checked .MuiSvgIcon-root path": {
                                            fill: "orange",
                                        },
                                        "&.Mui-selected": {
                                            backgroundColor: "#362C20!important",
                                            color: "#FA9C2B",
                                            width: "20px",
                                            height: "20px",
                                        },
                                    }}
                                />
                                {t("RAL1137")}
                            </MenuItem>
                            {projectsList &&
                                projectsList
                                    .filter((project) =>
                                        project.name
                                            ?.toLowerCase()
                                            .includes(tempProjectSearch?.toLowerCase())
                                    )
                                    .map((project) => (
                                        <MenuItem
                                            id={`select-item-projectfilter-${project?.name}`}
                                            key={project.id}
                                            selected={tempProjectFilter?.includes(project.id)}
                                            sx={{
                                                fontFamily: "Gotham",
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                fontWeight: "var(--fw-500)",
                                                backgroundColor: mode === "dark" ? "#1F1F1F" : "#FFFFFF",
                                                color: mode === "dark" ? "#f8f8f8cc" : "#242424cc",
                                                "&:hover": {
                                                    backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
                                                    color: "#FA9C2B",
                                                },
                                                "&.Mui-selected": {
                                                    backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
                                                    color: "#FA9C2B",
                                                },
                                                "&.Mui-selected:hover": {
                                                    backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
                                                    color: "#FA9C2B",
                                                },
                                            }}
                                            value={project.id}
                                            onClick={() => handleProjectFilterChange(project.id)}
                                        >
                                            <Checkbox
                                                id={`select-item-check-projectfilter-${project.name}`}
                                                checked={
                                                    tempProjectFilter.includes("all-project") ||
                                                    tempProjectFilter.includes(project.id)
                                                }
                                                sx={{
                                                    "& .MuiSvgIcon-root": {
                                                        border:
                                                            mode === "dark"
                                                                ? "1px solid #4D4D4D"
                                                                : "1px solid #B2B2B2",
                                                        borderRadius: "4px",
                                                        width: "20px",
                                                        height: "20px",
                                                    },
                                                    "&.Mui-checked .MuiSvgIcon-root": {
                                                        border: "none",
                                                    },
                                                    "&.Mui-checked": {
                                                        color: "orange",
                                                    },
                                                    "& .MuiSvgIcon-root path": {
                                                        fill: "transparent",
                                                    },
                                                    "&.Mui-checked .MuiSvgIcon-root path": {
                                                        fill: "orange",
                                                    },
                                                    "&.Mui-selected": {
                                                        backgroundColor: "#362C20!important",
                                                        color: "#FA9C2B",
                                                        width: "20px",
                                                        height: "20px",
                                                    },
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    wordBreak: "break-all",
                                                    whiteSpace: "normal",
                                                }}
                                            >
                                                {project.name.length > 24 ? (
                                                    <Tooltip
                                                        id={`select-item-projectfilter-${project.name}`}
                                                        title={project.name}
                                                        placement="top"
                                                    // arrow
                                                    >
                                                        <span id={`select-item-projectfilter-${project.name}`}>{`${project.name
                                                            .replace("null", "")
                                                            .substring(0, 24)}...`}</span>
                                                    </Tooltip>
                                                ) : (
                                                    <span> {project.name.replace("null", "")}</span>
                                                )}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                        </Box>
                    </Select>
                </Box>

                <Box>
                    <CustomizedDateRangePicker
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </Box>

                <Box
                    display="flex"
                    justifyContent="center"
                    mt={2}
                    gap={2}
                    pl={3}
                    pr={3}
                >
                    <Button
                        id="btn-rst-id"
                        name="btn-rst-name"
                        variant="outlined"
                        color="primary"
                        onClick={handleResetApply}
                        sx={{
                            font: "normal normal normal 16px/28px Gotham",
                            color: mode === "light" ? "var(--color-1)" : "var(--color-30)",
                            width: "150px",
                            height: "50px",
                            borderRadius: "5px",
                            background:
                                mode === "light"
                                    ? "var(--color-37) 0% 0% no-repeat padding-box"
                                    : "var(--color-9-00) 0% 0% no-repeat padding-box",
                            border:
                                mode === "light"
                                    ? "1px solid var(--color-1)"
                                    : "1px solid var(--color-30)",
                            padding: "10px",
                            "&:hover": {
                                background:
                                    mode === "light"
                                        ? "var(--color-37) 0% 0% no-repeat padding-box"
                                        : "var(--color-9-00) 0% 0% no-repeat padding-box",
                                border:
                                    mode === "light"
                                        ? "1px solid var(--color-1)"
                                        : "1px solid var(--color-30)",
                            },
                        }}
                    >
                        {t("RAL0077")}
                    </Button>
                    <Button
                        id="btn-aply-id"
                        name="btn-aply-name"
                        variant="contained"
                        color="primary"
                        onClick={handleApplyFilter}
                        sx={{
                            width: "150px",
                            height: "50px",
                            borderRadius: "5px",
                            padding: "25px",
                            background: "linear-gradient(99deg, #1D0B77 0%, #6A5FA2 100%)",
                            font: "normal normal normal 16px/28px Gotham",
                            color: "#FFFFFF",
                        }}
                    >
                        {t("RAL0230")}
                    </Button>
                </Box>
            </Box>


        </Popover>
    );
}